import { FileText, CheckCircle, UserPlus, Calendar, Check, LucideIcon } from 'lucide-react'
import type { ActivityType } from '@/types'

/**
 * Get the appropriate Lucide icon component for an activity type
 *
 * @param type - Activity type
 * @returns Lucide icon component
 */
export function getActivityIcon(type: ActivityType): LucideIcon {
  const iconMap: Record<ActivityType, LucideIcon> = {
    client_created: FileText,
    payable_approved: CheckCircle,
    assignment_created: UserPlus,
    payment_scheduled: Calendar,
    payment_completed: Check
  }

  return iconMap[type] || FileText
}

/**
 * Get the appropriate Tailwind color class for an activity type
 *
 * @param type - Activity type
 * @returns Tailwind CSS color class
 */
export function getActivityIconColor(type: ActivityType): string {
  const colorMap: Record<ActivityType, string> = {
    client_created: 'text-brand-primary',
    payable_approved: 'text-green-500',
    assignment_created: 'text-blue-500',
    payment_scheduled: 'text-yellow-500',
    payment_completed: 'text-green-500'
  }

  return colorMap[type] || 'text-brand-gray'
}

/**
 * Get the route path for an activity based on its type
 *
 * @param activity - Activity object with type and entityId
 * @returns Route path string
 */
export function getActivityRoute(type: ActivityType, entityId: string): string {
  const routeMap: Record<ActivityType, string> = {
    client_created: `/revfinops/clients/${entityId}`,
    payable_approved: `/revfinops/payables/${entityId}`,
    assignment_created: `/revfinops/assignments/${entityId}`,
    payment_scheduled: `/revfinops/payables/${entityId}`,
    payment_completed: `/revfinops/payables/${entityId}`
  }

  return routeMap[type]
}
